import { fromJS, Set } from 'immutable';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  FETCH_FAILED,
  FETCH_SUCCESS,
  SET_FETCH_PARAMS,
  SELECT_DONATION,
  OPEN_OVERVIEW,
  CLOSE_OVERVIEW,
  MATCH_DONATIONS_SUCCESS,
  UNMATCH_DONATIONS_SUCCESS,
  MATCH_DONATIONS,
  MATCH_DONATIONS_FAILED,
  UNMATCH_DONATIONS,
  UNMATCH_DONATIONS_FAILED,
  CANCEL_CORPORATE_DONATION,
  CANCEL_CORPORATE_DONATION_FAILED,
  CANCEL_CORPORATE_DONATION_SUCCESS,
} from './constants';

export const initialState = fromJS({
  loading: false,
  error: false,
  fetchParams: {
    sort: 'date',
    order: 'desc',
    search: '',
    pageNum: 0,
    limit: 10,
    type: '',
  },
  selectedDonations: Set(),
  isOverviewOpen: false,
  initialized: false,
});

function donationsListPageReducer(state = initialState, action) {
  switch (action.type) {
    case INIT:
      return state.merge({ loading: true, selectedDonations: Set() });

    case INIT_SUCCESS:
      return state.merge({ initialized: true });

    case INIT_FAILED:
      return state.merge({ error: action.error });

    case FETCH_FAILED:
      return state.merge({ loading: false, error: action.error });

    case FETCH_SUCCESS:
      return state.set('loading', false);

    case SET_FETCH_PARAMS:
      return state.merge({
        loading: true,
        selectedDonations: Set(),
        fetchParams: state.get('fetchParams').merge({ pageNum: 0, ...action.params }),
      });

    case SELECT_DONATION:
      if (state.get('selectedDonations').has(action.donationId)) {
        return state.set(
          'selectedDonations',
          state.get('selectedDonations').delete(action.donationId)
        );
      }
      return state.set('selectedDonations', state.get('selectedDonations').add(action.donationId));

    case OPEN_OVERVIEW:
      return state.set('isOverviewOpen', true);

    case CLOSE_OVERVIEW:
      return state.set('isOverviewOpen', false);

    case MATCH_DONATIONS:
      return state.set('loading', true);

    case MATCH_DONATIONS_FAILED:
      return state.merge({ loading: false, error: action.error });

    case MATCH_DONATIONS_SUCCESS: {
      const selectedDonations = state.get('selectedDonations').subtract(action.donationIds);
      return state.merge({
        loading: false,
        selectedDonations,
        isOverviewOpen: selectedDonations.size > 0,
      });
    }

    case UNMATCH_DONATIONS:
      return state.set('loading', true);

    case UNMATCH_DONATIONS_FAILED:
      return state.merge({ loading: false, error: action.error });

    case UNMATCH_DONATIONS_SUCCESS: {
      const selectedDonations = state.get('selectedDonations').subtract(action.donationIds);
      return state.merge({
        loading: false,
        selectedDonations,
        isOverviewOpen: selectedDonations.size > 0,
      });
    }

    case CANCEL_CORPORATE_DONATION:
      return state.set('loading', true);

    case CANCEL_CORPORATE_DONATION_FAILED:
      return state.merge({ loading: false, error: action.error });

    case CANCEL_CORPORATE_DONATION_SUCCESS:
      return state.merge({ loading: false });

    default:
      return state;
  }
}

export default donationsListPageReducer;
